import { ComponentPropsWithoutRef, forwardRef, ChangeEvent } from 'react';

import { IMaskInput } from 'react-imask';

type Props = ComponentPropsWithoutRef<'input'> & {
  mask?: string;
};

const definitions = {
  '9': /[0-9]/,
  A: /[A-Za-zА-Яа-я]/,
  '*': /./,
};

export const MaskedInput = forwardRef<HTMLInputElement, Props>(function MaskedInput(
  { mask = '', name, value, onChange, ...props },
  ref,
) {
  return (
    <IMaskInput
      {...props}
      name={name}
      mask={mask}
      definitions={definitions}
      value={String(value ?? '')}
      inputRef={ref}
      unmask={false}
      lazy
      onAccept={(nextValue, _, event) => {
        // Prop updates and form resets must not become user edits in React Hook Form.
        if (event) {
          onChange?.({ target: { name, value: nextValue } } as ChangeEvent<HTMLInputElement>);
        }
      }}
    />
  );
});
